import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import TopView from '@max/leez-top-view';
import Image from "@max/leez-image";
import ModalBaseContainer from '@max/leez-modal-base-container';
import './index.scss';
import { getFullScreenSize } from "@/utils/layout";
import { BID_MAP, BID_TYPE, SHARE_BUTTON_TYPE } from '@/constants';
const NoPrizeModal = ({ visible, onClose, onClick, lxReport }) => {
    const { fullScreenHeight } = getFullScreenSize();
    if (!visible) {
        return null;
    }
    lxReport === null || lxReport === void 0 ? void 0 : lxReport(BID_MAP.SHARE_BUTTON_MV, BID_TYPE.MV, {
        type: SHARE_BUTTON_TYPE.MODAL_SHARE
    });
    const renderContent = () => {
        return <View className="no-prize-modal-content-wrap">
        
        <Image className="no-prize-modal-content" source={{
            uri: 'https://p0.meituan.net/ingee/c82aff3a2154210315a53aff8096c9e3191608.png'
        }} style={{
            width: '566rpx',
            height: '499rpx'
        }} resizeMode='cover' borderRadius={0}>
          
          <View className="no-prize-modal-action-btn" onClick={onClick}/>
        </Image>

        
        <Image onPress={onClose} source={{
            uri: 'https://p0.meituan.net/ingee/94047ffc6fa8ede65644e7a2653da1691779.png'
        }} style={{
            width: '48rpx',
            height: '48rpx',
            marginTop: '52rpx'
        }} className="no-prize-modal-close-btn"/>
      </View>;
    };
    return <TopView>
      <ModalBaseContainer visible={visible} contentStyle={{
        width: '750rpx',
        height: fullScreenHeight,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
    }}>
        {renderContent()}
      </ModalBaseContainer>
    </TopView>;
};
export default memo(NoPrizeModal);
